<template>
  <base-modal :title="title" :width="width" :visible="visible" @cancel="open(false)">
    <div slot="modalBody">
      <a-form :form="form">
        <a-row>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="关联商机" hasFeedback>
              <a-input
                readOnly
                v-model="model.marketName"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="项目名称" hasFeedback>
              <a-input
                readOnly
                v-model="model.name"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="项目简称" hasFeedback>
              <a-input
                readOnly
                v-model="model.shortName"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="招标单位" hasFeedback>
              <a-input
                readOnly
                v-model="model.proprietorName"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="项目经理" hasFeedback>
              <a-input
                readOnly
                v-model="model.projectManagerName"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="商务经理" hasFeedback>
              <a-input
                readOnly
                v-model="model.businessManagerName"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="中标时间" hasFeedback>
              <a-input
                readOnly
                v-model="model.winningTime"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="中标价格" hasFeedback>
              <a-input
                prefix="￥"
                readOnly
                v-model="model.winningPrice"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="项目类型" hasFeedback>
              <a-input
                readOnly
                v-model="typeDesc"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="项目进度" hasFeedback>
              <a-input
                readOnly
                v-model="progressDesc"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </base-modal>
</template>

<script>
import baseModal from '@/CrComponents/Modal/Modal.vue'
export default {
  name: 'EditMarkets',
  mounted () {},
  computed: {
    typeDesc () {
      let typeDesc = ''
      if (this.model.type === 1) {
        typeDesc = '纯软件'
      } else if (this.model.type === 2) {
        typeDesc = '项目集成'
      }
      return typeDesc
    },
    progressDesc () {
      let progressDesc = ''
      if (this.model.progress === 1) {
        progressDesc = '需求调研'
      } else if (this.model.progress === 2) {
        progressDesc = '概要设计'
      } else if (this.model.progress === 3) {
        progressDesc = '详细设计'
      } else if (this.model.progress === 4) {
        progressDesc = '开发实施'
      } else if (this.model.progress === 5) {
        progressDesc = '测试调优'
      } else if (this.model.progress === 6) {
        progressDesc = '试运行'
      } else if (this.model.progress === 7) {
        progressDesc = '质保期'
      } else if (this.model.progress === 8) {
        progressDesc = '出质保'
      }
      return progressDesc
    }
  },
  components: {
    baseModal
  },
  data () {
    return {
      title: '操作',
      width: 1200,
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      form: this.$form.createForm(this, { name: 'markets' }),
      visible: false,
      defaultModel: {},
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      }
    }
  },
  methods: {
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel (model) {
      this.model = Object.assign({}, model)
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      this.formClear()
      this.visible = flag
    },
    formClear () {},
    cancel () {
      this.formClear()
      this.open(false)
    }
    // 获取select列表

  }
}
</script>

<style scoped lang="less">
.downloadList{
  margin-top: 10px;
  list-style: none;
  li{
    margin: 10px;
  }
}
</style>
